
import React from 'react';
import {SelectInput, TextInput, ImageInput, ImageField, Edit, SimpleForm, required, useTranslate } from 'react-admin';
import CardActions from '@material-ui/core/CardActions';
import { ListButton, Toolbar, SaveButton, DeleteButton } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';
import DateFnsUtils from '@date-io/date-fns';
import { DateInput } from 'react-admin-date-inputs2';
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
// import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import frLocale from "date-fns/locale/fr";
import {GENDER_MALE, GENDER_FEMALE} from '../../util/constant';

const toolbarStyles = {
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
};

const CustomToolbarNoStyle = ({permissions, ...props}) => (
    <Toolbar {...props}>
        <SaveButton />
        {/* {permissions === 'Admin' &&
        <DeleteButton label="ra.action.delete" redirect='list' {...props}/>} */}
    </Toolbar>
);
var genders = [];
genders.push({id: GENDER_MALE, name: 'Monsieur'});
genders.push({id: GENDER_FEMALE, name: "Madame"});

const CustomToolbar = withStyles(toolbarStyles)(CustomToolbarNoStyle);

const cardActionStyle = {
    zIndex: 2,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    padding: 0,
};

const EditActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
        <ListButton basePath={basePath}/>
    </CardActions>
);
const Title = ({ record }) => {
    const translate = useTranslate();
    return <span>{translate('resources.client.edit')}: {record ? `${record.email}` : ''}</span>;
};

const EditClient = ({classes, permissions, ...props })  => {
    const translate = useTranslate();
    const uploadFileText = translate('ra.input.file.upload_single') + '(' + translate('max_size') + '100KB)';
    return(
    <Edit title={<Title />} {...props} actions={<EditActions/>}>
         <SimpleForm redirect="list" 
                toolbar={<CustomToolbar permissions={permissions} />}>
                <TextInput source="email" label="Email" validate={required()} disabled/>
            <TextInput source="mobile" label="Mobile" validate={required()} disabled/>
            <SelectInput source="gender" label="Civilité" validate={required()} choices={genders}/>
            <TextInput source="last_name" label="Nom" validate={required()}/>
            <TextInput source="first_name" label="Prénom" validate={required()}/>
            {/* <ImageInput source="photo" label="Photo" accept="image/*" maxSize='100000' placeholder={uploadFileText}>
                <ImageField source="url" title="Fichier" />
            </ImageInput> */}

            {/* <DateInput source="birth_day" label="Date de naissance" locales="fr-FR"/> */}
            <MuiPickersUtilsProvider utils={MomentUtils}>
            <DateInput source="birth_date" label="Date de naissance" 
                autoComplete="" options={{ format: 'DD/MM/yyyy' }} 
                 providerOptions={{ utils: DateFnsUtils, locale: frLocale }}
            />
            </MuiPickersUtilsProvider>
            

        </SimpleForm>
    </Edit>
)};

export default EditClient;